import React, { Fragment } from 'react';
import { Button, Col, FormGroup, Input, Label, Row } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const GeographicShipping = ({
  handleShippingMoveItems,
  handleShippingSelectAll,
  handleShippingSelectItem,
  shipData
}) => {
  const { exclude, include } = shipData;

  return (
    <Fragment>
      <h3 className="mt-5">Geographic Shipping Rules</h3>
      <p>
        Use the arrow buttons to build shipping rules based on geographic location for this sale.
        Locations listed under &ldquo;We will ship to&rdquo; will be displayed on site as places
        where your house is able to ship purchased items to.
      </p>
      <p>
        Note: Buyers from the locations under &ldquo;We will NOT ship to&rdquo; will not be allowed
        to purchase items in your sale.
      </p>

      <Row>
        <Col xs={5}>
          <FormGroup>
            <Label className="font-weight-bold" for="shippingTo">
              We will ship to:
            </Label>
            <div id="shippingTo" className="shipping-container p-3 overflow-auto">
              {include.length > 0
                && include.map(includeItem => (
                  <FormGroup className="d-flex" key={includeItem.countryCode}>
                    <Input
                      id={`include-${includeItem.countryCode}`}
                      className="ml-0 mt-1 position-relative"
                      checked={includeItem.selected}
                      name={includeItem.countryCode}
                      onChange={e => handleShippingSelectItem(e, 'include')}
                      type="checkbox"
                    />
                    <Label className="ml-2" for={`include-${includeItem.countryCode}`}>
                      {includeItem.countryName}
                    </Label>
                  </FormGroup>
                ))}
            </div>
            {include.length > 0 && (
              <Button color="link" onClick={() => handleShippingSelectAll('include')}>
                {include.every(item => item.selected) ? 'Deselect' : 'Select'} All
              </Button>
            )}
          </FormGroup>
        </Col>
        <Col className="mt-5" xs={2}>
          <div className="pt-5 mt-5 text-center">
            <button
              className="shipping-arrow-button cursor-pointer border-0"
              onClick={() => handleShippingMoveItems('right')}
              type="button"
            >
              <FontAwesomeIcon className="color-blue" icon="arrow-circle-right" size="2x" />
            </button>
          </div>
          <div className="pb-5 mt-5 text-center">
            <button
              className="shipping-arrow-button cursor-pointer border-0"
              onClick={() => handleShippingMoveItems('left')}
              type="button"
            >
              <FontAwesomeIcon className="color-blue" icon="arrow-circle-left" size="2x" />
            </button>
          </div>
        </Col>
        <Col xs={5}>
          <FormGroup>
            <Label className="font-weight-bold" for="notShippingTo">
              We will NOT ship to:
            </Label>
            <div id="shippingTo" className="shipping-container p-3 overflow-auto">
              {exclude.length > 0
                && exclude.map(excludeItem => (
                  <FormGroup className="d-flex" key={excludeItem.countryCode}>
                    <Input
                      id={`exclude-${excludeItem.countryCode}`}
                      className="ml-0 mt-1 position-relative"
                      checked={excludeItem.selected}
                      name={excludeItem.countryCode}
                      onChange={e => handleShippingSelectItem(e, 'exclude')}
                      type="checkbox"
                    />
                    <Label className="ml-2" for={`exclude-${excludeItem.countryCode}`}>
                      {excludeItem.countryName}
                    </Label>
                  </FormGroup>
                ))}
            </div>
            {exclude.length > 0 && (
              <Button color="link" onClick={() => handleShippingSelectAll('exclude')}>
                {exclude.every(item => item.selected) ? 'Deselect' : 'Select'} All
              </Button>
            )}
          </FormGroup>
        </Col>
      </Row>
    </Fragment>
  );
};

export default GeographicShipping;
